module.exports = __webpack_public_path__ + "assets/img/6_459.bd17dcb9.jpg";